import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const ProfilePicture = styled.img`
    width: 130px;
    height: 130px;
    border-radius: 50%;
    border: 8px solid #FFF;
`